/* MANO 2026-10-25: native, scroll-scrubbed UPLIFT -> EASE -> RESET (reversible).
 * No wheel/touch hijacking, no gesture locks. Same visual interpolation up/down.
 */
(()=>{
  const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
  const smooth=(a,b,p)=>{const t=clamp((p-a)/(b-a),0,1);return t*t*(3-2*t)};
  function mount(){
    const root=document.querySelector('[data-mano-root]');
    if(!root||root.dataset.manoScrollReady==='yes')return;
    const scene=root.querySelector('[data-mano-scene]');
    const header=root.querySelector('[data-mano-header]');
    const menu=root.querySelector('[data-mano-open]');
    const cans=[...root.querySelectorAll('[data-mano-can]')];
    const bgs=[...root.querySelectorAll('[data-mano-bg]')];
    const dots=[...root.querySelectorAll('[data-mano-go]')];
    const name=root.querySelector('[data-mano-name]');
    const desc=root.querySelector('[data-mano-description]');
    const indicator=root.querySelector('[data-mano-index]');
    if(!scene||!header||!menu||!name||!desc||!indicator||cans.length!==3||bgs.length!==3)return;
    root.dataset.manoScrollReady='yes';
    const labels=[root.dataset.manoLabelUplift||'UPLIFT',root.dataset.manoLabelEase||'EASE',root.dataset.manoLabelReset||'RESET'],flavours=[root.dataset.manoFlavourUplift||'Blood Orange',root.dataset.manoFlavourEase||'Rose & Lychee',root.dataset.manoFlavourReset||'Mixed Berry'];
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    let selected=-1,raf=0;
    function render(){
      raf=0;
      const bounds=scene.getBoundingClientRect();
      const height=window.innerHeight||document.documentElement.clientHeight;
      const distance=Math.max(1,bounds.height-height);
      const progress=clamp(-bounds.top/distance,0,1);
      // Two overlapping, gently eased transitions separated by stable holds.
      // 0.00-.16 UPLIFT | .16-.40 morph to EASE | .40-.60 EASE |
      // .60-.84 morph to RESET | .84-1.00 RESET.
      const rawStage=smooth(.16,.40,progress)+smooth(.60,.84,progress);
      const stage=reduced.matches?Math.round(rawStage):rawStage;
      cans.forEach((el,i)=>{
        const d=Math.abs(i-stage),alpha=clamp(1-d,0,1);
        el.style.opacity=alpha.toFixed(4);
        el.style.transform='translate3d(0,'+((i-stage)*12).toFixed(2)+'px,0) scale('+(1-.028*d).toFixed(4)+')';
        el.style.visibility=alpha<.005?'hidden':'visible';
        el.setAttribute('aria-hidden',String(alpha<.5));
      });
      bgs.forEach((el,i)=>{el.style.opacity=clamp(1-Math.abs(i-stage),0,1).toFixed(4)});
      const nearest=clamp(Math.round(stage),0,2);
      if(selected!==nearest){
        selected=nearest;
        name.textContent=labels[nearest];
        desc.textContent=flavours[nearest];
        indicator.textContent='0'+(nearest+1);
        dots.forEach((dot,i)=>{
          dot.classList.toggle('is-active',i===nearest);
          dot.setAttribute('aria-pressed',String(i===nearest));
        });
      }
      const note=root.querySelector('.mano-flavour-notes');
      if(note)note.style.opacity=(1-clamp(Math.abs(stage-nearest)*1.8,0,.9)).toFixed(3);
      header.classList.toggle('is-solid',bounds.bottom<height*.85);
    }
    function requestRender(){if(!raf)raf=requestAnimationFrame(render)}
    window.addEventListener('scroll',requestRender,{passive:true});
    window.addEventListener('resize',requestRender,{passive:true});
    reduced.addEventListener?.('change',requestRender);
    dots.forEach(dot=>dot.addEventListener('click',()=>{
      const n=clamp(Number(dot.dataset.manoGo)||0,0,2);
      const sceneTop=window.scrollY+scene.getBoundingClientRect().top;
      const travel=Math.max(0,scene.offsetHeight-window.innerHeight);
      const target=[0.04,.5,.96][n];
      window.scrollTo({top:sceneTop+travel*target,behavior:reduced.matches?'auto':'smooth'});
    }));
    function close(){root.classList.remove('menu-open');menu.setAttribute('aria-expanded','false')}
    menu.addEventListener('click',()=>{
      const open=root.classList.toggle('menu-open');
      menu.setAttribute('aria-expanded',String(open));
    });
    root.querySelectorAll('[data-mano-close],.mano-drawer a').forEach(el=>el.addEventListener('click',close));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
    render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);
  else mount();
  document.addEventListener('shopify:section:load',mount);
})();